import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  price: ModelRegistry['price'];
}

interface BookingPriceTablesIndexSignature {
  Element: null;

  Args: IArgs;
}

export default abstract class UiBookingPriceTablesBaseComponent extends Component<BookingPriceTablesIndexSignature> {
  @cached
  get price(): ModelRegistry['price'] {
    return this.args.price;
  }

  @cached
  get currency(): string {
    return this.price.currency;
  }

  @cached
  get booking(): ModelRegistry['booking'] {
    return this.price.booking;
  }
}
